<template>
    <ViewPaiement />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    
import ViewPaiement from "@/components/GesCom/Paiement/ViewPaiement.vue";
  
    export default defineComponent({
      name: "ViewPaiementPage",
      components: {
        
        ViewPaiement,
      },
    });
  </script>